<template>
  <v-card class="align-stretch" height="100%">
    <v-card-title>
      <span class="mr-1">Installation Address</span>
      <InfoTooltip top>
        The address used when the customer contacts the emergency services
      </InfoTooltip>
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="$emit('open-edit-dialog')"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Address line one</p>
          <p><b>{{(currentVoipSite.installation_address!==undefined && currentVoipSite.installation_address!==null)?currentVoipSite.installation_address.line_one:'-'}}</b></p>
          <p class="mb-1 text-caption">Address line two</p>
          <p><b>{{(currentVoipSite.installation_address!==undefined && currentVoipSite.installation_address!==null)?currentVoipSite.installation_address.line_two:'-'}}</b></p>
          <p class="mb-1 text-caption">City</p>
          <p><b>{{(currentVoipSite.installation_address!==undefined && currentVoipSite.installation_address!==null)?currentVoipSite.installation_address.city:'-'}}</b></p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">County</p>
          <p><b>{{(currentVoipSite.installation_address!==undefined && currentVoipSite.installation_address!==null)?currentVoipSite.installation_address.county:'-'}}</b></p>
          <p class="mb-1 text-caption">Post Code</p>
          <p><b>{{(currentVoipSite.installation_address!==undefined && currentVoipSite.installation_address!==null)?currentVoipSite.installation_address.post_code:'-'}}</b></p>
          <p class="mb-1 text-caption">Country</p>
          <p><b>{{(currentVoipSite.installation_address!==undefined && currentVoipSite.installation_address!==null)?currentVoipSite.installation_address.country:'-'}}</b></p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import InfoTooltip from '@/components/Base/InfoTooltip';

  export default {
    props: [ 'currentVoipSite' ],
    
    components: {
      InfoTooltip
    },
  }
</script>

<style lang="scss" scoped></style>
